import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ModalName } from "src/app/enums/modal-name";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-success-modal",
  templateUrl: "./success-modal.component.html",
  styleUrls: ["./success-modal.component.scss"],
})
export class SuccessModalComponent {
  @Input() title = "Thank You!";
  @Input() text = "Your application has been accepted for processing.";
  @Input() buttonText = "Close";

  @Output() close = new EventEmitter<void>();

  constructor(private readonly _modalService: ModalService) {}

  get isOpen() {
    return this._modalService.openedModalName === ModalName.Success;
  }

  onClose() {
    this._modalService.closeModal();
    this.close.emit();
  }
}
